<template>
  <section class="content">
    <div class="loading-overlay" v-if="loading">
      <div class="spinner"></div>
      <h4>Loading Data...</h4>
    </div>
      <div class="box box-info">
        <accountChildsubgroupdialog ref="openDialog"/>
        <accountChildSubHeadList @delete-message="deleteMessage" @edit-account="editAccount" @loading-started="loading = true"
        @loading-finished="loading = false"/>
      </div>
  </section>
</template>
<script>
import accountChildSubHeadList from './accountChildSubHeadList.vue'
import accountChildsubgroupdialog from '../accountDialog/AccountChildSubGroupDialog.vue'

export default {
  name: 'accountSubgroup',
  data() {
    return {
      loading: false
    }
  },
  methods: {
    editAccount(data) {
      this.$refs.openDialog.editAccount(data)
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    accountChildSubHeadList,
    accountChildsubgroupdialog
  }
}
</script>
<style scoped>
/* Loading Overlay Styles */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-overlay h4 {
  font-size: 1.5rem;
  color: #2c3e50;
}
</style>




// WEBPACK FOOTER //
// AccountSubGroupChild.vue?8173ae8c